import getCheckoutItemViewsWithLoyaltyUpgradeAvailable from 'checkout/selectors/loyalty/getCheckoutItemViewsWithLoyaltyUpgradeAvailable'
import getHotelItemViews from 'checkout/selectors/view/itemViews/getHotelItemViews'
import getLoyaltyBenefitAvailability from 'loyalty/lib/determineLoyaltyBenefitAvailability'
import getLoyaltyStayUpgradeBenefit from 'loyalty/selectors/getLoyaltyStayUpgradeBenefit'
import getCanShowRegionSpecificLoyaltyUI from 'loyalty/selectors/getCanShowRegionSpecificLoyaltyUI'
import { createSelector } from 'reselect'

const getCanRedeemStayUpgradeLoyaltyBenefit = createSelector(
  (state: App.State) => getLoyaltyStayUpgradeBenefit(state),
  (state: App.State) => getCheckoutItemViewsWithLoyaltyUpgradeAvailable(state),
  (state: App.State) => getHotelItemViews(state),
  (state: App.State) => getCanShowRegionSpecificLoyaltyUI(state),
  (
    stayUpgradeBenefit,
    itemViewsWithLoyaltyUpgradeAvailable,
    hotelOfferViews,
    canShow,
  ): boolean => {
    if (!stayUpgradeBenefit || !getLoyaltyBenefitAvailability(stayUpgradeBenefit)) return false
    if (!canShow) return false
    /**
     * Ideally `!!itemViewsWithLoyaltyUpgradeAvailable.length` should be accurate enough,
     * but we're not supporting multi accommodation items yet.
     * For that reason, we only enable the benefit section if there's only **one** accommodation item.
     */
    return hotelOfferViews.data.length === 1 && itemViewsWithLoyaltyUpgradeAvailable.length === 1
  },
)

export default getCanRedeemStayUpgradeLoyaltyBenefit
